import React, { useState, useContext, useEffect } from 'react';
import HeaderLayout from '../layouts/Header';
import FooterLayout from '../layouts/Footer';
import FooterWithCopyright from '../layouts/FooterWithCopyright';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import "./Main.css";
import LoginModal from '../modals/LoginModal';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-datepicker/dist/react-datepicker.css';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../AuthContext';

const ActivateCodePage = () => {

    const [isLoginModalVisible, setIsLoginModalVisible] = useState(false);
    const showLoginModal = () => setIsLoginModalVisible(true);
    const cancelLoginModal = () => setIsLoginModalVisible(false);

    const [code, setCode] = useState('');
    const navigate = useNavigate();
    const [error, setError] = useState('');

    const { token, isAuthenticated, loading, user, fetchData } = useContext(AuthContext);

    const handleFormSubmit = async (event) => {
        event.preventDefault();

        // console.log(token);
    
        if (code.length < 5) {
            
            alert("Please put correct format of code.");
            return;
        }
    
        const data = {
            code: code,
            userId: user.id
        };
    
        try {
            const response = await fetch(process.env.REACT_APP_API_URL+'/api/activation/activate', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(data),
            });
    
            if (response.ok) {
                
                const responseData = await response.json();

                if(responseData.success == false){
                    setError(responseData.message);
                }
                else{
                    await fetchData();
                    setError('');
                    navigate(`/profile`);
                }
            } else {
                console.error('Failed to add ID:', response.statusText);
                setError(response.statusText);
            }
        } catch (error) {
            console.error('Error add ID:', error);
            setError(error.message);
        }
    };

    useEffect(() => {
        if(!isAuthenticated){
            navigate('/');
        }
    }, [loading]);

    return (
        <div className="background-element">
            <HeaderLayout onLoginClick={showLoginModal}/>

            <div className="page-content-container">
                
                <h1 className="page-text">Enter Activation Code</h1>

                
                <div className="form-container mt-3">
                    <form onSubmit={handleFormSubmit} className="border p-4 rounded shadow-sm bg-light">
                        {error !== '' ? (
                            <h3 className="error-message">Error : {error}</h3>
                        ):
                            <></>
                        }
                        <div className="mb-3">
                            <label className="form-label">Enter Activation Code</label>
                            <input
                                type="text"
                                className="form-control"
                                value={code}
                                onChange={(e) => setCode(e.target.value)}
                                placeholder="Enter Activation Code"
                                required
                            />
                        </div>
                        <button type="submit" className="btn btn-primary w-100">
                        Submit
                        </button>
                    </form>
                </div>
            </div>

            <FooterLayout onLoginClick={showLoginModal}/>
            <FooterWithCopyright/>

            <LoginModal visible={isLoginModalVisible} onClose={cancelLoginModal} />
        </div>
    );
};

export default ActivateCodePage;
